import React from "react";
import Grid from "@mui/material/Grid";
import "./style.css";
import backgroundImage from "./images/bg-roof-panels-gradient.png";
import Rating from "@mui/material/Rating";
import Skeleton from "@mui/material/Skeleton"; // added skeleton import
// import Collapse from "@mui/material/Collapse"; // removed collapse import
// Removed Table, TableBody, TableCell, TableContainer, TableRow, Paper imports

export function getBulletIcons(profileDetails) {
    const bulletIcons = {
        yearEstablished: {
            icon: 'fa-calendar',
            text: 'Established in ' + profileDetails.yearEstablished
        },
        panelWarranty: {
            icon: 'fa-bolt',
            text: profileDetails.panelWarranty + ' Panel Warranty'
        },
        workmanshipWarranty: {
            icon: 'fa-wrench',
            text: profileDetails.workmanshipWarranty + ' Workmanship Warranty'
        },
        totalStaff: {
            icon: 'fa-users',
            text: profileDetails.totalStaff + ' Staff'
        },
        annualInstallations: {
            icon: 'fa-check',
            text: profileDetails.annualInstallations + ' Annual Installations'
        },
        publicLiabilityInsurance: {
            icon: 'fa-calculator',
            text: 'Public Liability Insurance'
        },
        dedicatedSupport: {
            icon: 'fa-phone',
            text: 'Dedicated Support Team'
        },
        seaiApproved: {
            icon: 'fa-thumbs-up',
            text: 'SEAI Approved Installer'
        }
    };
    return bulletIcons;
}

import { useState, useEffect } from "react";
import { useTheme } from '@mui/material/styles';
import Button from '@mui/material/Button';
import EmojiEventsIcon from '@mui/icons-material/EmojiEvents';

const Card = ({ profileDetails, name, url, slug, profileVerified, profileStatus }) => {
    // Fetch Google reviews data
    const [placeData, setPlaceData] = useState({});

    useEffect(() => {
        if (!profileDetails.placeId) return;
        fetch('https://c9rtj2s6a4.execute-api.eu-west-1.amazonaws.com/prod/companies/google-reviews', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ placeId: profileDetails.placeId }),
        })
            .then(res => res.json())
            .then(data => {
                setPlaceData(data.result || {});
            })
            .catch(err => console.error('Failed to fetch reviews', err));
    }, [profileDetails.placeId]);

    const bullets = profileDetails.bullets || {};
    const bulletIcons = getBulletIcons(profileDetails);
    const bulletKeys = Object.keys(bullets).filter(key => bullets[key]);

    // Responsive paddingLeft for desktop/mobile
    const isMobile = typeof window !== 'undefined' && window.innerWidth <= 600;
    const responsivePaddingLeft = isMobile ? 16 : 224;
    // Update mobile name left offset to match ProviderSummary
    const nameLeft = isMobile ? 124 : 224;
    const nameWidth = isMobile ? `calc(100% - 110px)` : `calc(100% - 224px)`;

    // Use MUI theme primary color
    const theme = useTheme();
    const primaryColor = theme.palette.primary.main || '#229626';

    // Remove card-level padding, add to top section only
    return (
        <div style={{
            border: `2px solid ${primaryColor}`,
            borderRadius: 11,
            background: '#fff',
            boxSizing: 'border-box',
            overflow: 'hidden',
            position: 'relative'
        }}>
            {/* Tag/Bookmark */}
            <div style={{
                position: 'absolute',
                top: 0,
                right: 0,
                background: primaryColor,
                color: '#fff',
                fontWeight: 700,
                fontSize: 15,
                padding: '8px 18px 8px 22px',
                borderTopRightRadius: 11,
                borderBottomLeftRadius: 18,
                zIndex: 30,
                boxShadow: '0 2px 8px rgba(0,0,0,0.07)',
                letterSpacing: 0.2,
                display: 'flex',
                alignItems: 'center',
                minWidth: 170
            }}>
                <EmojiEventsIcon style={{ marginRight: 8, fontSize: 22, color: '#fff', filter: 'drop-shadow(0 1px 2px rgba(0,0,0,0.10))' }} />
                Top Rated Installer
            </div>
            {/* Top Section with background and profile image */}
            <Grid container spacing={2} alignItems="flex-start" style={{ 
                position: "relative", // ensure absolute children are positioned relative to this container
                paddingTop: isMobile ? 100 : 60,
                paddingBottom: 60,
                paddingLeft: responsivePaddingLeft,
                backgroundImage: `url(${backgroundImage})`,
                backgroundSize: 'cover',
                backgroundRepeat: 'no-repeat',
                backgroundPosition: 'right center', // crop from left if needed
                minHeight: 86,
                borderTopLeftRadius: 11,    // radius for top corners only
                borderTopRightRadius: 11,
                borderBottomLeftRadius: 0,  // flat bottom corners
                borderBottomRightRadius: 0
            }}>
                {profileDetails.logo && (
                    <Grid container justifyContent="left" size={2} style={{ marginBottom: -20, position: "absolute", left: 30 }}>
                        {(() => {
                            const isMobile = typeof window !== 'undefined' && window.innerWidth <= 600;
                            const imgSize = isMobile ? 90 : 150;
                            const imgPadding = isMobile ? 10 : 20;
                            return (
                                <img
                                    src={profileDetails.logo}
                                    alt="Logo"
                                    style={{
                                        width: imgSize,
                                        height: imgSize,
                                        aspectRatio: "1/1",
                                        objectFit: "contain",
                                        borderRadius: "50%",
                                        backgroundColor: "#fff",
                                        border: "1px solid #ABDC8B",
                                        maxWidth: "none"
                                    }}
                                />
                            );
                        })()}
                    </Grid>
                )}
                {/* New Name Display - updated for vertical centering */}
                <Grid item xs={12} style={{
                    position: "absolute",
                    left: nameLeft,
                    zIndex: 20,
                    width: nameWidth,
                    bottom: isMobile ? 5 : 'auto',
                    top: isMobile ? 'auto' : '50%',
                    transform: isMobile ? 'none' : 'translateY(-50%)'
                }}>
                    <Grid container direction="column" alignItems="flex-start" style={{ padding: 20 }}>
                        <Grid item>
                            <h1 style={{ color: "#023a51", fontSize: isMobile ? "28px" : "35px", fontWeight: "700", margin: 0, font: "Manrope" }}>
                                {name}
                            </h1>
                        </Grid>
                        {profileVerified === 'Verified' && (
                            <Grid item style={{ marginTop: 8 }}>
                                <Grid container alignItems="center" wrap="nowrap" style={{ flexWrap: 'nowrap' }}>
                                    <Grid item>
                                        <img 
                                            src="https://energyefficiency.ie/wp-content/uploads/2025/02/verified.png" 
                                            alt="Verified" 
                                            style={{ width: 20, height: 20, marginRight: 8, display: 'block' }}  // updated style
                                        />
                                    </Grid>
                                    <Grid item>
                                        <span style={{ fontSize: '18px', color: '#229626', lineHeight: 1, display: 'flex', alignItems: 'center' }}>
                                            Verified Installer
                                        </span>
                                    </Grid>
                                </Grid>
                            </Grid>
                        )}
                    </Grid>
                </Grid>

            </Grid>
            {/* Bottom Section with bullet points and (conditionally) reviews */}
            <Grid
                container
                direction="column"
                spacing={1}
                style={{
                    marginTop: 20,
                    paddingLeft: isMobile ? 30 : responsivePaddingLeft,
                    paddingRight: isMobile ? 30 : 0
                }}
            >
                {/* Only show reviews and divider if there is a Place ID */}
                {profileDetails.placeId && (
                  <>
                    {/* Google Ratings only (Opening Hours removed) */}
                    <Grid container spacing={2} alignItems="center" style={{ marginBottom: 8 }}>
                        <Grid item size={{sx: 12, sm: 6}} style={{ marginTop: isMobile ? 24 : 0 }}>
                            {(!placeData.url || typeof placeData.rating === 'undefined' || typeof placeData.user_ratings_total === 'undefined') ? (
                                <Skeleton variant="text" width={300} height={30} />
                            ) : (
                                <a 
                                    href={placeData.url} 
                                    target="_blank" 
                                    className="reviews-link"
                                    style={{ 
                                        color: "blue",  
                                        display: "flex", 
                                        alignItems: "center", 
                                        lineHeight: 1 
                                    }}
                                >
                                    <span style={{ lineHeight: 1 }}>{placeData.rating}</span>
                                    <Rating 
                                        name="read-only" 
                                        value={Number(placeData.rating)} 
                                        precision={0.1} 
                                        readOnly 
                                        style={{ marginLeft: 10, lineHeight: 1 }}
                                    />
                                    <span style={{ marginLeft: 10, lineHeight: 1 }}>
                                        ({placeData.user_ratings_total} Google Ratings)
                                    </span>
                                </a>
                            )}
                        </Grid>
                    </Grid>
                    {/* Divider between ratings/opening hours and bullets */}
                    <hr style={{
                        border: 0,
                        borderTop: '1.5px solid #d6eac7',
                        margin: '0px 0 10px 0',
                        width: '100%'
                    }} />
                  </>
                )}
                {/* Bullet Points */}

                <Grid item>
                    <Grid container spacing={2} style={{ paddingTop: 15, paddingBottom: 10 }}>
                        {(isMobile ? bulletKeys.slice(0, 4) : bulletKeys).map(key => (
                            <Grid key={key} size={isMobile ? 12 : 6} style={{ display: "flex", alignItems: "center" }}>
                                <i className={`fa ${bulletIcons[key].icon}`} 
                                   style={{ 
                                       marginRight: 15, 
                                       display: "flex", 
                                       alignItems: "center", 
                                       justifyContent: "center", 
                                       minWidth: 30, 
                                       color: primaryColor
                                   }}>
                                </i>
                                <span>{bulletIcons[key].text}</span>
                            </Grid>
                        ))}
                    </Grid>
                </Grid>

                {/* Request a Quote Button */}
                {profileStatus === 'Published' ? (
                    <Grid item style={{ textAlign: isMobile ? 'center' : 'left', marginTop: 20, marginBottom: 45 }}>
                        <Button
                            variant="contained"
                            color="primary"
                            size="large"
                            component="a"
                            href={`https://energyefficiency.ie/solar-panels/installers/${slug}/`}
                        >
                            View Profile
                        </Button>
                    </Grid>
                ) : (
                    <div style={{ height: 25 }} />
                )}



            </Grid>
        </div>
    );
};

export default Card;
